<template>
  <div id="babyFeedDetails" class="babyFeedDetails">

    <div v-lazy:background-image="videoInfo.coverUrl" class="video-detail">
      <Back @goBack="goBack">
        <div slot="header">
          <div class="back">
            <img alt="" src="@/assets/images/babyFeeding/detalis-back.png">
          </div>
        </div>
      </Back>
      <child-video
          v-show="showVideo"
          ref="childVideo"
          :userInfo="userInfo"
          :videoDetail="videoInfo"
          :videoId="videoInfo.id"
          class="video-child"
          @isLogin="isLoginUser"
          @videoEnd="videoEnd"
          @viedoAccomplish="viedoAccomplish"
          @viedoSuspend="viedoSuspend"
      ></child-video>
      <img alt class="play-icon" src="@/assets/images/icon/off.png" @click="playerVideo"/>
    </div>
    <!-- 儿歌信息 -->
    <div class="details-intro">
      <h3>{{ videoInfo.title }}</h3>
      <div v-if="videoInfo.tag" class="intro-label">
        <p v-for="item in (videoInfo.tag.split(','))" :key="item">{{ item }}</p>
      </div>
      <div ref="introText" class="intro-text">
        <p>{{ videoInfo.contentDesc }}</p>
      </div>
      <!--      <p :class="['simula-text',spread?'textBottom':'']" @click="handleUnfold">-->
      <!--        {{ spread ? '收起' : '展开' }}-->
      <!--        <img alt="" src="@/assets/images/babyFeeding/details-zhankai.png">-->
      <!--      </p>-->
    </div>
    <div class="details-main">
      <!--   星选食材（小程序来源时隐藏）   -->
      <feedChooseTitle v-if="!checkFromMiniprogram && ingredientList.length" :title="2"></feedChooseTitle>
      <foodChoose v-if="!checkFromMiniprogram && ingredientList.length" :ingredientList="ingredientList"></foodChoose>
      <!--   制作方法   -->
      <div class="main-da-btn">
        <h5><img alt="" src="@/assets/images/babyFeeding/zhizuofangf.png"></h5>
        <div class="btn-bgs">
          <div class="btn-imgs">
            <img :src="videoInfo.imgUrl" alt="">
          </div>
        </div>
      </div>
      <!--  为宝宝下厨房（小程序来源时隐藏）    -->
      <feedKitchen v-if="!checkFromMiniprogram && recipesList.length" :currentId="videoInfo.tagId" :recipesList="recipesList"
                   @handleKitchen="handleKitchen"></feedKitchen>
      <!--      宝妈都在买（小程序来源时隐藏）-->
      <feedChooseTitle v-if="!checkFromMiniprogram && ShopList.length" :title="1"></feedChooseTitle>
      <foodChoose v-if="!checkFromMiniprogram && ShopList.length" :ingredientList="ShopList"></foodChoose>
    </div>

    <!-- 评论（小程序来源时隐藏，包含点赞/收藏/浏览交互） -->
    <div v-if="!checkFromMiniprogram" class="comments">
      <comment-field
          ref="focus"
          :Info="videoInfo"
          :articalId="videoInfo.id"
          :carrierId="carrierId"
          :commentTotal="commentTotal"
          :currentTop="currentTop"
          :foodSendImg="foodInitImg"
          :isFoodDetail="1"
          :isGoLogin="isGoLogin"
          :title="videoInfo.recipeName"
          parentApiType="lucky"
          @clearPic="clearcommentPic"
          @focusOn="getFocusOn"
          @handleCollect="handleCollect"
          @reviewSuccess="reviewSuccess"
          @sendPiclen="getPiclen"
          @sendUpload="getUpimg"
          @type="getType"
          @videoSupport="videoSupport"
      ></comment-field>
      <all-comment
          ref="allComment"
          :articalId="videoInfo.id"
          :carrierId="carrierId"
          :isGoLogin="isGoLogin"
          :title="videoInfo.recipeName"
          @comTotal="comTotal"
          @focusOn="getFocusOn"
          @type="getType"
      ></all-comment>
    </div>
    <!-- 微信分享弹窗（小程序来源时隐藏） -->
    <audioShare v-if="!checkFromMiniprogram" ref="share"></audioShare>
    <!-- 登录注册弹窗 -->
    <login-tip
        :show="checkLogin"
        @cancleWay="cancleWay"
        @confirmWay="confirmWay"
    ></login-tip>
  </div>
</template>
<script
    src="https://res.wx.qq.com/open/js/jweixin-1.2.0.js"
    type="text/javascript"
></script>
<script>
//工具类
import {
  fomatterNum,
  gainReady,
  getCookie,
  getHeadImgAndName,
  getUrlParamsByName,
  isFromMiniprogram, // 小程序来源判断方法
  is_weixin,
  isUserLogin,
  setCookie,
  TestUserAgent
} from "@/assets/js/common.js";
//头部返回组件
import Back from "@/components/common/goBack";
//API接口
//视频播放组件
import childVideo from "@/components/contents/calendar/video.vue";
import commentField from "@/views/contents/foodColumn/component/commentField.vue"; //评论
import allComment from "@/views/contents/foodColumn/component/allcomment.vue"; //评论
//分享弹窗
import audioShare from "@/components/comment/share.vue";
// 宝妈都在买
import foodChoose from "@/components/contents/babyFeeding/foodChoose/index"
// 为宝宝下厨房
import feedKitchen from "@/components/contents/babyFeeding/recipes/feedKitchen"
import feedChooseTitle from '@/components/contents/babyFeeding/foodChoose/feedChooseTitle'; //title组件
import loginTip from "@/views/contents/calendar/component/logintip";
import {BuiedPointClick_Fn, Exposurer_feeding_Fn, Exposurer_xmhh5BbspTitleView_Fn} from "@assets/js/BuriedPointEvent";
import Api from "@/utils/axiosApi/babyFeedingApi";
import harvardApi from '@/utils/axiosApi/harvardApi'
import wx from "weixin-js-sdk";

export default {
  name: 'babyFeedDetails',
  data() {
    return {
      ABtest: "",
      fomatterNum: fomatterNum,
      //carrierId传值11为喂养之道
      carrierId: "11",
      // 视频播放状态
      showVideo: false,
      //用户信息
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      //当前视频详情
      videoInfo: {},
      checkLogin: false,
      state: false,
      spread: false, // 是否展开
      commentTotal: "", //评论总数
      viedoSFHow: false,//视频已播放完曝光
      foodInitImg: [], //图片数组
      ingredientList: [],//食材优选
      recipesList: [],//为宝宝下厨房
      ShopList: [],//宝妈都在买
      babyFeedYue: {},
      currentTop: '',
      upperIds: [],
      oneState: false
    };
  },
  components: {
    feedKitchen,
    childVideo,
    commentField,
    allComment,
    Back,
    audioShare,
    loginTip,
    foodChoose,
    feedChooseTitle
  },
  watch: {
    '$route.params': {
      handler(newValue) {
        this.initPage()
      },
      deep: true,
      immediate: true
    },
    upperIds: {
      handler(newValue) {
        // this.$nextTick(() => {
        //   console.log(newValue, 'newValue')
        //   this.playerVideo()
        // })
      },
      deep: true
    },

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 不是来源于注册页的，再往session中设置值
      if (!getUrlParamsByName('fromLogin')) {
        sessionStorage.setItem("pre", from.path)
      }
      vm.$store.commit('plusIncludes', 'babyFeedDetails')
    })
  },
  beforeRouteLeave(to, from, next) {
    this.viedoSuspend()
    next()
  },
  activated() {
    // this.upperIds = []
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener(
          'WeixinJSBridgeReady',
          function () {
            setTimeout(() => {
              document.getElementsByTagName('video')[0].play()
            }, 500)
          },
          false
      )
    })
  },
  created() {
    this.babyFeedYue = JSON.parse(localStorage.getItem('babyFeedYue')) || {}
    this.videoInfo.id = this.$route.params.id
    console.log('created', 'newValue')
    this.oneState = sessionStorage.getItem('oneState')
    // this.initPage()
  },
  methods: {
    isUserLogin, getCookie, setCookie, is_weixin, gainReady,
    // 点赞
    videoSupport() {
      BuiedPointClick_Fn("xmhh5_bbsp_dainzan", {
        xmhh5_bbsp_title: this.videoInfo.title,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
        xmhh5_bbsp_hudongweizhi:
            this.$route.name != "babyFeedDetails" ? "其他食谱列表" : "食谱详情页",
      });
    },
    // 收藏
    handleCollect() {
      BuiedPointClick_Fn("xmhh5_bbsp_shoucang", {
        xmhh5_bbsp_title: this.videoInfo.title,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
        xmhh5_bbsp_hudongweizhi:
            this.$route.name != "babyFeedDetails" ? "其他食谱列表" : "食谱详情页",
      });
    },
    getUpimg(fileList, callback) {
      console.log(fileList);
      if (fileList.length != 0) {
        var length = fileList.length;
        var formdata = new FormData();
        formdata.append("files", fileList);
        try {
          this.$http.post(
              "/upload/batchPictureFile",
              {ContentType: "application/x-www-form-urlencoded"},
              formdata,
              (res) => {
                if (res.code === "200") {
                  this.foodInitImg = this.foodInitImg.concat(res.data);
                  this.total = this.len - this.foodInitImg.length;
                  callback();
                } else if (res.code === "500") {
                  this.foodInitImg = [];
                  this.$toast({
                    message: "服务器异常，程序猿小哥哥正在努力修复~",
                    duration: 2000,
                  });
                } else {
                  this.foodInitImg = [];
                  this.$toast({
                    message: res.message,
                    duration: 2000,
                  });
                }
              }
          );
        } catch (err) {
          this.foodInitImg = [];
          if (err.code === "500") {
            this.$toast({
              message: "服务器异常，程序猿小哥哥正在努力修复~",
              duration: 2000,
            });
          } else {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          }
        }
      }
    },
    // 获取评论 总数
    getFeedComments(id) {
      harvardApi.getComments({}, {
        page: 1,
        size: 25,
        data: {
          carrierId: this.carrierId,
          crmId: this.userInfo ? this.userInfo.crm_id : "",
          carrierSpecificId: id
        }
      }, res => {
        if (res.code == '200') {
          this.commentTotal = res.data.total
        }
        console.log(res, 'getComments')
      })

    },
    getPiclen(num) {
      this.total = this.len - num;
    },
    comTotal(val) {
      this.commentTotal = val;
    },
    // 清除图片数组
    clearcommentPic() {
      this.total = this.len;
      this.foodInitImg = [];
    },
    initPage() {
      sessionStorage.removeItem('currentPlayStatus')
      // 初始化
      // this.getVideoDetail(this.$route.params.id);
      this.getFeedFindById(this.$route.params.id);
      this.getIngredient(this.$route.params.id)
      this.getUserName()
      this.getFeedComments(this.$route.params.id)

      this.getFeedShop()
    },
    initFeedEventAdd(id) {
      Api.feedEventAdd({
        watchNum: this.videoInfo.watchNum,
        num: 1,
        itemId: id,
        crmId: this.userInfo?.crm_id || "",
        collectNum: 0,
        likeNum: 0
      }, res => {
        if (res.code == 200) {
          console.log(res, '浏览')
        }
      })
    },
    isLoginUser(state) {
      this.state = state
      if (this.isUserLogin()) {
        this.checkLogin = true;
        this.$refs.childVideo.switchVideoa()
        this.$nextTick(() => {
          this.$refs.childVideo.Player.pause();
          this.$refs.childVideo.Player.currentTime = 9;
        })
      }
    },
    //视频结束
    videoEnd(value) {
      console.log(this.videoInfo, 'xmhh5_bbsp_videoplay')
      const babyFeedYue = JSON.parse(localStorage.getItem('babyFeedYue')) || {}
      BuiedPointClick_Fn("xmhh5_bbsp_videoplay", {
        xmhh5_bbsp_title: this.videoInfo.title,
        xmhh5_bbsp_monthage: babyFeedYue?.name,
        xmhh5_bbsp_quitplaytime: value
      })

      this.viedoSFHow = true
    },
    //视频暂停
    viedoSuspend(value) {
      if (!this.viedoSFHow && value) {
        const babyFeedYue = JSON.parse(localStorage.getItem('babyFeedYue')) || {}
        BuiedPointClick_Fn("xmhh5_bbsp_videoplay", {
          xmhh5_bbsp_title: this.videoInfo.title,
          xmhh5_bbsp_monthage: babyFeedYue.name,
          xmhh5_bbsp_quitplaytime: value
        })
      }
    },
    // 视频播放80% 以上
    viedoAccomplish(value) {
      const babyFeedYue = JSON.parse(localStorage.getItem('babyFeedYue')) || {}
      BuiedPointClick_Fn('xmhh5_bbsp_videoplay_end', {
        xmhh5_bbsp_title: this.videoInfo.title,
        xmhh5_bbsp_monthage: babyFeedYue.name,
        xmhh5_bbsp_quitplaytime: value
      })
    },
    handleRoute() {
      this.$router.push({path: '/recipeSearchList'})
    },
    reviewSuccess() {
      BuiedPointClick_Fn('xmhh5_bbsp_pinglun', {
        xmhh5_bbsp_title: this.videoInfo.title,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name
      })
    },
    // 确认
    confirmWay() {
      this.checkLogin = false;
    },
    // 取消
    cancleWay() {
      this.$refs.childVideo.Player.pause();
      this.$refs.childVideo.Player.currentTime = 9;
      this.checkLogin = false;
    },
    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool
    },
    getType(type) {
      this.$refs.focus.type = type
    },
    // 返回上一页
    goBack() {
      // alert(this.upperIds.length)
      this.gainReady(null, () => {
        if (this.upperIds.length) {
          this.getFeedFindById(this.upperIds[this.upperIds.length - 1], true)
          this.getIngredient(this.upperIds[this.upperIds.length - 1])
          // this.getfeedRecommend(this.upperIds[this.upperIds.length - 1])
          this.getFeedShop()
          scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth'
          })
          this.upperIds.splice(this.upperIds.length - 1, 1)
        } else {
          if (window.history.length > 1) {
            this.$router.go(-1)
          } else {
            this.$router.replace("/babyFeeding")
          }
        }
      })

    },
    // 为宝宝下厨房数据点击
    handleKitchen(item) {
      this.spread = false
      this.upperIds.push(this.videoInfo.id)
      this.videoInfo = {}
      this.getFeedFindById(item.id, true)
      this.getIngredient(item.id)
      // this.getfeedRecommend(item.id)
      this.getFeedShop()
      console.log(this.upperIds, 'this.upperIds')
      this.spread = false
      BuiedPointClick_Fn("xmhh5_bbsp_click", {
        xmhh5_bbsp_title: item.oldTitle ? item.oldTitle : item.title,
        xmhh5_bbsp_viewstation: this.$route.meta.xmhh5_bbsp_viewstation,
        xmhh5_bbsp_monthage: this.babyFeedYue?.name,
      });
      // this.playerVideo()
      scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth'
      })
      // this.$router.push({path: "/babyFeedDetails/" + item.id});
    },
    //食材选购
    getIngredient(value) {
      const feedTag = sessionStorage.getItem('feedTag')
      Api.starFood({id: value}, (res) => {
        if (res.code == "200") {
          this.ingredientList = res.data || [];
        } else {
          this.$toast(res.message);
        }
      });
    },
    //为宝宝下厨房
    getfeedRecommend(id, feedTag) {
      // const feedTag = sessionStorage.getItem('feedTag')
      Api.feedRecommendList({
        tagId: feedTag,
        crmId: this.userInfo ? this.userInfo.crm_id : "",
      }, res => {
        if (res.code == '200') {
          const arr = res.data.filter(item => item.id != id)
          this.recipesList = arr.filter((item, index) => index < 4)
          console.log(this.recipesList, '接口数据111')
        }
      })
    },
    // 宝妈都在买
    getFeedShop() {
      Api.feedShop({}, res => {
        if (res.code == 200) {
          this.ShopList = res.data;
        }
      })
    },
    // 判断 当前页面的环境
    setgain(callback) {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            callback && callback(1)
          } else {
            callback && callback(2)
          }
        });
      }
    },
    getFeedFindById(id, type = false) {
      this.videoInfo = {}
      Api.feedFindById({
        id: id,
        crmId: this.userInfo ? this.userInfo?.crm_id : "",
      }, res => {
        if (res.code == 200) {
          const {isAndroid} = TestUserAgent()
          // this.videoInfo.videoUrl = res.data.contentUrl;
          this.videoInfo = {
            ...res.data,
            videoUrl: res.data.contentUrl,
            coverUrl: res.data.coverUrl,
          };
          this.getfeedRecommend(id, res.data.tagId)
          console.log(this.videoInfo, 'this.videoInfo')
          Exposurer_feeding_Fn.observe('xmhh5_bbsp_allpageview', '.baby_feed_Index', false, {
            xmhh5_bbsp_pagename: '食谱详情页',
            xmhh5_bbsp_monthage: this.babyFeedYue?.name || "",
            xmhh5_bbsp_title: this.videoInfo.title
          })
          this.setgain((value) => {
            Exposurer_xmhh5BbspTitleView_Fn.observe('xmhh5BbspTitleView', '.babyFeedDetails', false, {
              xmhh5_bbsp_Source: value === 1 ? '星妈优选小程序' : '星妈会h5'
            })
          })

          this.initFeedEventAdd(this.$route.params.id)
          if (type) {
            this.$nextTick(() => {
              this.$refs.childVideo.Player.src = res.data.contentUrl
              // this.playerVideo()
            })
          } else {
            this.$nextTick(() => {
              if (!sessionStorage.getItem('player') || !isAndroid) {
                this.playerVideo()
                sessionStorage.setItem('player', 1)
              }

            })
            // if (isAndroid) {
            //   this.$nextTick(() => {
            //     this.playerVideo()
            //   })
            // } else {
            //   if (this.oneState) {
            //     this.$nextTick(() => {
            //       this.playerVideo()
            //     })
            //   } else {
            //     sessionStorage.setItem('oneState', true)
            //   }
            // }
          }

          var shareDataParams = {
            shareLink: location.href.split("#")[0],
            shareDesc: '点击查看详细食谱做法，1000+宝宝食谱，就在星妈会',
            shareTitle: res.data.title,
            imgUrl: res.data.coverSubUrl, //必须是绝对路径
            shareid: res.data.id,
            shareFlag: true,
            shareType: 'songs'
          }
          this.wxJsSet.wxShare("fx", shareDataParams, this);
          setTimeout(() => {
            this.currentTop = $(".commentWrap").offset().top;
            console.log("this.currentTop", this.currentTop);
          }, 500);
        }
      })

    },
    //播放视频
    playerVideo() {
      console.log('===============================')
      this.showVideo = true;
      this.$refs.childVideo.initPlayer();
      // $('.video-detail').attr('style', 'background:none') //去掉封面图
    },
    getUserName: async function () {
      try {
        const {headImgurl, nickName} = await getHeadImgAndName()
        this.setCookie("xmh_headimgurl", headImgurl, 365);
        this.setCookie("xmh_nickname", nickName, 365);
      } catch (err) {

      }
    },
  },
  destroyed() {
    sessionStorage.removeItem('player')
  },
  computed: {
    isGoLogin() {
      return this.isUserLogin();
    },
    // 判断当前页面是否来自星妈会小程序，用于控制部分模块在小程序内隐藏
    checkFromMiniprogram() {
      return isFromMiniprogram(this.$route);
    },
  },
};
</script>
<style lang="less" scoped>
#babyFeedDetails {
  min-height: 100vh;
  height: auto;
  background: #fff;

  .childVideo {
    height: 100%;
  }

  .commentShare {
    img {
      width: 14px !important;
      height: 14px !important;
    }
  }

  .video-detail {
    position: relative;
    width: 100%;
    height: 203px;
    background-size: 100% 100% !important;

    .play-icon {
      width: 48px;
      height: 48px;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      transform: translate(-50%, -50%);
    }

    .back {
      position: absolute;
      left: 0;
      top: 10px;
      z-index: 999;

      img {
        width: 28px;
        margin-left: 10px;
      }
    }

    .info {
      color: #fff;

      .player-num {
        position: absolute;
        bottom: 10px;
        left: 10px;
      }

      .player-time {
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }
  }

  .video-detail::after {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-color: rgba(0, 0, 0, 0.3);

    z-index: 1;
    width: 100%;
    height: 100%;
  }

  .details-intro {
    padding: 9px 12px 11px 12px;
    min-height: 70px;
    height: auto;
    position: relative;

    h3 {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 8px;
    }

    .intro-label {
      display: flex;
      font-size: 12px;
      color: #EA872C;
      font-weight: 400;

      p {
        border-radius: 4px;
        border: 1px solid rgba(250, 222, 91, 0.6);
        margin-left: 4px;
        padding: 2px 3px;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        -webkit-box-orient: vertical; //盒子中内容竖直排列
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 1; //行数
        line-clamp: 1;
        word-break: break-all;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .intro-text {
      //padding: 0 8px 0 12px;
      margin-top: 6px;
      font-size: 13px;
      position: relative;

      p {
        width: 100%;
        font-weight: 400;
        //line-height: 18px;
        overflow: hidden; //溢出内容隐藏
        //text-overflow: ellipsis; //文本溢出部分用省略号表示
        //-webkit-box-orient: vertical; //盒子中内容竖直排列
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        word-break: break-all;
      }
    }

    .simula-text {
      font-size: 12px;
      font-weight: 500;
      color: #EA872C;
      position: absolute;
      right: 24px;
      bottom: 13px;

      img {
        width: 10px;
      }
    }

    .textBottom {
      bottom: 0 !important;

      img {
        transform: rotateX(180deg);
      }
    }
  }

  .details-main {
    background: rgba(246, 246, 246, 1);
    padding: 0 12px 10px 12px;

    ::v-deep .foodChoose-header {
      margin: 0;
      padding: 16px 0 10px 0;
    }

    .main-da-btn {
      padding-top: 19px;

      h5 {
        img {
          height: 18px;
        }

        margin-bottom: 10px;
      }

      .btn-bgs {
        //background: #fff;
        border-radius: 8px;

        .btn-imgs {
          //height: 528px;
          //background: red;
          text-align: center;

          img {
            width: 350px;
            border-radius: 10px;
          }
        }
      }
    }
  }

  ::v-deep .comments {
    .myComment {
      //background: #fedbf0;
      background: rgba(254, 219, 240, .5);
      color: #F470BE;
      padding-top: 5px;
      display: inline-block;
    }

    .wrap {
      background: #f6f6f6;
    }

    .commentWrap {
      background: #f6f6f6;

      .van-search {
        background-color: #f6f6f6;
      }

      .commentList {
        background: #f6f6f6;

        .food-bottom {

          .commentLike {
            i {
              color: #F470BE !important;
              //background: #ff0000 !important;
            }

          }
        }

        ::v-deep .van-icon-good-job {
          color: #F470BE !important;
        }
      }

    }
  }


  //::v-deep .bottom {
  //  ::v-deep .box {
  //    ::v-deep
  //  }
  //
  //}
}

</style>